import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import AbstractTable from '../../../common/AbstractTable';
import ListActionItems from '../../../List/ListActionItems';
import { FormattedDate, FormattedTime } from 'react-intl';

import { TableRow, TableRowColumn, TableHeaderColumn } from 'material-ui/Table';

class StreamList extends AbstractTable {
  static propTypes = {
    ...AbstractTable.propTypes,
    onChangeFilter: PropTypes.func,
    displayStatus: PropTypes.bool
  };

  defaultProps = {
    displayStatus: false
  };

  confirmRemoveMessage = (
    <FormattedMessage
      id="record.remove"
      defaultMessage="Are you sure you want to delete stream video?"
    />
  );

  _renderHeader() {
    const { tableHeaderStyle, fixedHeaderStyle } = this.getStyles();
    return (
      <TableRow>
        <TableHeaderColumn style={tableHeaderStyle}>Name</TableHeaderColumn>
        <TableHeaderColumn style={tableHeaderStyle}>
          Start Time
        </TableHeaderColumn>
        <TableHeaderColumn style={fixedHeaderStyle}>Actions</TableHeaderColumn>
      </TableRow>
    );
  }

  _renderContentItem(item, key) {
    let { title, startDate, full_name } = item;

    const { tableColumnStyle, fixedColumnStyle } = this.getStyles();

    return (
      <TableRow key={key}>
        <TableRowColumn style={tableColumnStyle}>
          {title || full_name}
        </TableRowColumn>
        <TableRowColumn style={tableColumnStyle}>
          {this._renderFullTime(startDate)}
        </TableRowColumn>
        <TableRowColumn style={fixedColumnStyle}>
          <ListActionItems
            edit={this.props.edit}
            remove={this.props.delete}
            record={item}
            published={true}
            confirmMessageLabel={this.confirmRemoveMessage}
          />
        </TableRowColumn>
      </TableRow>
    );
  }

  _renderFullTime(date) {
    return date ? (
      <span>
        <FormattedDate value={date} />{' '}
        <FormattedTime value={date} format="short" />
      </span>
    ) : (
      <span>-</span>
    );
  }
}

export default StreamList;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamPast/StreamPast.jsx